<template>
  <div>
    <a-card title="客户管理" class="card">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="迅投账户" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-select v-model="searchForm.is_active" placeholder="状态" allowClear style="width: 100%" @change="search">
            <a-select-option :value="true">启用</a-select-option>
            <a-select-option :value="false">禁用</a-select-option>
          </a-select>
        </a-col>

        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange">
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? '#32CD99' : '#856363'">{{value ? '启用' : '禁用'}}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button  size="small" @click="editFormModal(item)">编辑</a-button>
              <a-button  size="small" @click="openFormModal(item)">充值</a-button>
              <a-popconfirm v-if ="item.is_active===1" title="确定禁用吗"@confirm="sStop_(item.id)">
                <a-button type="danger"  size="small">禁用</a-button>
              </a-popconfirm>
              <a-popconfirm v-if ="item.is_active===0" title="确定启用吗"@confirm="sStart_(item.id)">
                <a-button type="primary"  size="small">启用</a-button>
              </a-popconfirm>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger"  size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <!--form-modal v-model="visible" :form="targetItem" :clientsClassificationOptions="clientsClassificationItems"
      @create="create" @update="update" /-->
    <!--form-modal v-model="visible"  :visible1="visible1" :visible2="visible2"  :form="targetItem" :roleItems="roleItems"  @create="create" @update="update" /-->
    <form-modal v-model="visible"  :visible1="visible1" :visible2="visible2"  :form="targetItem" :roleItems="roleItems" @create="create" @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { exportExcel } from "@/utils/excel";
import { clientExport } from "@/api/export";
import { clientTemplate, clientImport } from "@/api/import";
import { clientList, clientDestroy,sStart,sStop } from "@/api/custom";
import { memberType,memberBuyCreate } from "@/api/member";
import { getClientNumber } from "@/api/data";

export default {
  name: "Client",
  components: {
    //FormModal: () => import("./FormModal.vue"),
    FormModal: () => import("./FormModalEdit.vue"),
  },
  data () {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          width: 60,
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
         {
          title: "迅投账户",
          dataIndex: "p_user_name",
          sorter: true,
        },
        {
          title: "券商账户",
          dataIndex: "q_user_name",
          sorter: true,
        },
        {
          title: "原单姓名",
          dataIndex: "y_c_name",
          sorter: true,
        },
        {
          title: "个股金额",
          dataIndex: "c_amt",
          sorter: true,
        },
        {
          title: "持股个数",
          dataIndex: "c_num",
          sorter: true,
        },
        {
          title: "联系方式",
          dataIndex: "y_c_phone",
          sorter: true,
        },
        {
          title: "跟单姓名",
          dataIndex: "y_g_name",
          sorter: true,
        },
        {
          title: "会员",
          dataIndex: "member",
          sorter: true,
        },
        {
          title: "到期时间",
          dataIndex: "end_time",
        },
        {
          title: "允许交易",
          dataIndex: "is_active",
          key: "is_active",
          scopedSlots: { customRender: "is_active" },
        },
        {
          title: "运行策略",
          dataIndex: "strategy",
        },
        {
          title: "运行状态",
          dataIndex: "work_status",
          
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "156px",
        },
      ],
      searchForm: { search: "", page: 1, page_size: 12 },
      pagination: { current: 1, total: 0, pageSize: 12 },
      loading: false,
      items: [],
      clientsClassificationItems: [],
      visible: false,
      visible1: false,
      visible2: false,
      targetItem: {},
      roleItems: [],
      form: { is_active: true },
      importLoading: false,
    };
  },
  computed: {},
  methods: {
    initialize () {
      this.list();
      memberType({ page_size: 1000000 }).then((data) => {
        this.roleItems = data.results;
      });
    },
    list () {
      this.loading = true;
      clientList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.total;
          this.items = data.results;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create (item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update (item) {
      this.items.splice(
        this.items.findIndex((i) => i.id == item.id),
        1,
        item
      );
    },
    search () {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal (item) {
      if (!item.id) {
        getClientNumber().then((data) => {
          this.targetItem = { ...item, ...{ number: data.number } };
        });
      } else {
        this.targetItem = { ...item };
      }

      this.visible = true;
      this.visible2 = true;
      this.visible1 = false;
    },
    editFormModal (item) {
      if (!item.id) {
        getClientNumber().then((data) => {
          this.targetItem = { ...item, ...{ number: data.number } };
        });
      } else {
        this.targetItem = { ...item };
      }

      this.visible = true;
      this.visible2 = false;
      this.visible1 = true;
    },
    destroy (id) {
      clientDestroy({ id }).then((data) => {
        if (data.code==0){
        this.$message.success("删除成功");
        this.list();
        } else{
          this.$message.error(data.msg);
        }
      });
    },
    sStop_ (id) {
      sStop({ id }).then((data) => {
        // this.items.splice(
        //   this.items.findIndex((item) => item.id == id),
        //   1
        // );
        if (data.code==0){
        this.$message.success("停用成功");
        this.list();
        } else{
          this.$message.error(data.msg);
        }
      });
    },
    sStart_ (id) {
      sStart({ id }).then((data) => {
        // this.items.splice(
        //   this.items.findIndex((item) => item.id == id),
        //   1
        // );
        if (data.code==0){
        this.$message.success("启用成功");
        this.list();} else{
          this.$message.error(data.msg);
        }
      });
    },
    exportExcel () {
      clientExport(this.searchForm)
        .then((resp) => {
          exportExcel(resp.data, "客户列表");
          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    downloadTemplate () {
      clientTemplate()
        .then((resp) => {
          exportExcel(resp.data, "客户导入模板");
          this.$message.success("模板导出成功");
          this.list();
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    importExcel (item) {
      let data = new FormData();
      data.append("file", item.file);
      this.importLoading = true;
      setTimeout(() => {
        clientImport(data)
          .then(() => {
            this.$message.success("导入成功");
            this.list();
          })
          .catch((err) => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange (pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
  },
  mounted () {
    this.initialize();
  },
};
</script>
<style scoped>
.card {
  border-radius: 8px;
}
</style>
